<template>
    <div class="login-header">
        <img src="@/assets/back-black.png" @click="goBack" />
        欢迎来到九方智投股圈
    </div>
</template>

<script>
export default {
    name: "Header",
    methods: {
        goBack() {
            this.$router.go(-1)
        }
    }
}
</script>

<style lang="stylus" scoped>
.login-header
    height 54px
    font-size 17px
    font-weight 500
    color #091127
    line-height 54px
    text-align center
    border-bottom 1px solid #F5F5F5
    position relative

    img
        width 10px
        height 20px
        position absolute
        left 10px
        bottom 17px
</style>
